export default () => ({
  componentName: 'cell-source',
});
